import { FC } from "react";
import { ButtonBox, InputDatePicker, TextBox, PrivilegesChecker } from "..";
import { InputDatePickerTimeDisplayModeEnum, PageEnum } from "../../models";
import { getLabelName } from "../../utils";
import { EinvoiceTransactionSearchParamsModel } from "../../models/einvoiceTransaction/einvoiceTransactionModel";

interface SearchEInvoiceTransactionFieldsProps {
  searchParams: EinvoiceTransactionSearchParamsModel;
  onUpdateSearchParam: (
    key: keyof EinvoiceTransactionSearchParamsModel,
    value: any
  ) => void;
  onSearch: () => void;
  onReset: () => void;
  loading: boolean;
}

export const SearchEInvoiceTransactionFields: FC<
    SearchEInvoiceTransactionFieldsProps
> = ({ searchParams, onUpdateSearchParam, onSearch, onReset, loading }) => {
  return (
    <div className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-md-4 g-sm-4 mb-1 align-items-center mb-3">
      <InputDatePicker
        selectedDate={searchParams.fromDate}
        isClearable
        InputLabel={getLabelName("From Date")}
        selectsEnd
        timeMode={InputDatePickerTimeDisplayModeEnum.TimeSelect}
        className="form-control"
        endDate={searchParams.toDate}
        onChange={(date) =>
          onUpdateSearchParam("fromDate", date === null ? undefined : date)
        }
      />

      <InputDatePicker
        selectedDate={searchParams.toDate}
        isClearable
        InputLabel={getLabelName("To Date")}
        selectsEnd
        timeMode={InputDatePickerTimeDisplayModeEnum.TimeSelect}
        startDate={searchParams.fromDate}
        className="form-control"
        minDate={searchParams.fromDate}
        onChange={(date) =>
          onUpdateSearchParam("toDate", date === null ? undefined : date)
        }
      />

      <TextBox
        labelName={getLabelName("chkTransactionNo")}
        inputName={"transactionIdTextBox"}
        inputValue={searchParams.transactionId?.toString() || ""}
        onChange={(e: any) => {
          const value = e.target.value ? Number(e.target.value) : undefined;
          onUpdateSearchParam("transactionId", value);
        }}
      />

      <div className="w-full border-1">
        <TextBox
          inputName="isSuccess"
          inputValue={!searchParams.isSuccess}
          labelName={getLabelName("Fail To Upload")}
          type="checkbox"
          onChange={(e: any) => {
            const value = e.target.checked;
            onUpdateSearchParam("isSuccess", !value);
          }}
        />
      </div>

      <div
        style={{
          width: "66%",
        }}
        className=" d-flex justify-content-end align-items-center p-0"
      >
        <PrivilegesChecker
          formId={PageEnum.ManageEInvoices}
          action="EnableSearch"
        >
          <ButtonBox
            iconType="account-search"
            className="btn btn-primary btn-md mx-2 mb-2"
            onClick={onSearch}
            disabled={loading}
          >
            {getLabelName("Search")}
          </ButtonBox>
        </PrivilegesChecker>

        <ButtonBox
          iconType="receipt"
          variant="danger"
          className="btn btn-danger btn-md mb-2"
          onClick={onReset}
          disabled={loading}
        >
          {getLabelName("Reset")}
        </ButtonBox>
      </div>
    </div>
  );
};
